import { Component, Input, OnInit } from '@angular/core';
import { AbstractFieldComponent } from '../../abstract/abstract-field.component';
import { Observable } from 'rxjs/Rx';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {FormFieldService} from '../../../services/form-field.service';
import {isArray} from '../../../../core/utils/utils';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-radio-with-message',
  templateUrl: './radio-with-message.component.html',
  styleUrls: ['./radio-with-message.component.scss']
})
export class RadioWithMessageComponent extends AbstractFieldComponent implements OnInit {
  @Input() fieldConfig: AppRadioWithMessageFieldConfig;

  constructor(public formFieldService: FormFieldService,
              private ts: TranslateService) {
    super(formFieldService);
  }

  ngOnInit() {
    this.handleStatusChanges();
  }

  hasPriceConfig(config: any): boolean {
    return isNotNullOrUndefined(config.mainPrice) && isNotNullOrUndefined(config.tailsPrice);
  }

  async valueLabel() {
    return new Promise(res => {
      setTimeout(() => {
        if (isArray(this.fieldConfig.radioConfig)) {
          const radioConfig = (<any[]>this.fieldConfig.radioConfig).find(radioOption => radioOption.value === this.control.value);
          if (isNotNullOrUndefined(radioConfig)) {
            const label = this.ts.instant(radioConfig.label);
            const currency = this.ts.instant(radioConfig.currency);
            res(`${label} ${radioConfig.boldedLabel} ${currency}`);
          }
        }
        res(this.control.value);
      }, 0);
    });
  }

}

export interface AppRadioWithMessageFieldConfig {
  fieldKey: string;
  radioConfig: RadioWithMessageConfig | any[];
}

export interface RadioWithMessageConfig {
  value: string,
  label: string,
  boldedLabelPart: string,
  message: Observable<string>,
  currency?: string;
  boldedLabel?: string;
}
